import {Injectable} from "@angular/core";
import {Store} from "@ngrx/store";
import {selectUserSession} from "../../selectors/index";

const USER_KEY = 'User';

@Injectable()
export class SessionService {

  private sessionStorage = sessionStorage;

  constructor(private store: Store<any>) {
    selectUserSession(store).subscribe(session => {
      if (session && session.Facility) {
        this.setFacility(session.Facility);
      }
    })
  }

  getUser(): User {
    return <User>JSON.parse(this.sessionStorage.getItem(USER_KEY))
  }

  setUser(user: User) {
    this.sessionStorage.setItem(USER_KEY, JSON.stringify(user))
  }

  setFacility(facility: Facility) {
    const user = this.getUser();
    user.LastFacility = facility;
    this.setUser(user);
  }

  touchSession() {
    this.sessionStorage.setItem("LastActiveTimestamp", new Date().toISOString());
  }

  getAccessToken() {
    return this.sessionStorage.getItem('AccessToken');
  }

  setAccessToken(token) {
    this.sessionStorage.setItem('AccessToken', token)
  }

  getCurrentFacility() {
    return this.sessionStorage.getItem('CurrentFac')
  }
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/services/session/session.service.ts